import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/layout/AppShell";
import { Building2, Globe, Mail, MapPin } from "lucide-react";

export default function Customers() {
  const [customers, setCustomers] = useState(null);
  useEffect(() => { api.get("/customers").then((r) => setCustomers(r.data)); }, []);

  return (
    <>
      <PageHeader title="Customers" subtitle="Organisations you're running discovery for." />
      <div className="flex-1 px-6 py-8 lg:px-10">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
          {customers?.map((c) => (
            <div key={c.id} data-testid={`customer-card-${c.id}`} className="rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-md">
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl brand-gradient text-white"><Building2 className="h-5 w-5" /></div>
                <div>
                  <h3 className="font-heading text-base font-bold text-slate-900">{c.name}</h3>
                  <p className="text-xs font-medium capitalize text-slate-400">{c.industry}</p>
                </div>
              </div>
              <div className="mt-5 space-y-2 text-sm text-slate-600">
                {c.country && <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-slate-400" /> {c.country}</div>}
                {c.website && <div className="flex items-center gap-2"><Globe className="h-4 w-4 text-slate-400" /> <span className="truncate">{c.website}</span></div>}
                {c.email && <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-slate-400" /> {c.email}</div>}
              </div>
              {c.primary_contact && <div className="mt-4 border-t border-slate-100 pt-3 text-xs text-slate-400">Primary contact: <span className="font-semibold text-slate-600">{c.primary_contact}</span></div>}
            </div>
          ))}
          {customers && customers.length === 0 && (
            <div className="col-span-full rounded-2xl border border-dashed border-slate-300 bg-white p-16 text-center text-slate-400">No customers yet.</div>
          )}
        </div>
      </div>
    </>
  );
}
